import React, { useMemo, ReactElement } from 'react';
import FlexContainer from '../flex-container/flex-container.component';
import FilteredLink from '../filtered-link/filtered-link.component';
import TextBlock from '../text-block/text-block.component';
import IconOffsetBlock from '../icon-offset-block/icon-offset-block.component';
import CheckAccess from '../check-access/check-access.component';
import ActionButton from '../action-button/action-button.component';
import AttachmentIcon from '../../icons/attachment-icon';
import MoreIcon from '../../icons/more-icon';
import FormatService from '../../services/format-service';

const FileLink: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const OFFSET_TOP_ICON: number = 3;

  const {
    isDisabled,
    withActionMenu,
    fileLink,
    actionProps,
    actionMenuItems,
    actionMenuPermissions,
    entityTypeProp,
    extraEntityTypeProp,
    onClick,
    onMouseDown,
    onOpenActionMenu,
    onCheckIsMenuItemVisible,
  } = props;

  const fileLinkText: string | null = fileLink && fileLink.name ? FormatService.formatFileName(fileLink.name) : null;

  const withVisibleItems: boolean = useMemo((): boolean => (
    actionMenuItems ? actionMenuItems.reduce((
      withVisibleItemsResult: boolean, actionMenuItem: ActionMenuItem,
    ): boolean => {
      const linkedEntityType: string = actionProps && actionProps[entityTypeProp];
      const linkedExtraEntityType: string = actionProps && actionProps[extraEntityTypeProp];

      return withVisibleItemsResult || (onCheckIsMenuItemVisible ? onCheckIsMenuItemVisible(
        actionMenuItem,
        entityTypeProp ? linkedEntityType : null,
        extraEntityTypeProp ? linkedExtraEntityType : null,
      ) : true);
    }, false) : false
  ), [actionMenuItems, actionProps, entityTypeProp, extraEntityTypeProp]);

  return (
    <FlexContainer>
      <TextBlock>
        <IconOffsetBlock offsetTop={OFFSET_TOP_ICON}>
          <AttachmentIcon />
        </IconOffsetBlock>
      </TextBlock>
      {
        !!fileLink && (
          <FlexContainer>
            <FilteredLink
              isExternal
              link={!isDisabled ? fileLink.link : undefined}
              onClick={onClick}
              onMouseDown={onMouseDown}
            >
              {fileLinkText}
            </FilteredLink>
          </FlexContainer>
        )
      }
      {
        withActionMenu && withVisibleItems && (
          <CheckAccess permissions={actionMenuPermissions}>
            <ActionButton
              withPopup
              withSmallPadding
              onClick={onOpenActionMenu}
              {...(actionProps || {})}
            >
              <MoreIcon />
            </ActionButton>
          </CheckAccess>
        )
      }
    </FlexContainer>
  );
});

export default FileLink;
